<template lang="html">
  <div class="dashboard">
    <!-- <v-header :name="name" :isDashboard="!child" :onBack="true" @backClick="backToDashboard"></v-header> -->
    <v-header :name="name" isDashboard></v-header>
    <div class="container">
      <div class="left"> 
        <div class="item">
          <v-salesData :salesOrderAnalysis="salesOrderAnalysis" v-if="show"></v-salesData>
        </div>       
        <div class="item item2">
        <v-harvestingPlan  v-if="show" :regionalRanking="regionalRanking"></v-harvestingPlan>
        </div>
      </div>
      <div class="center">
        <v-center v-if="show" :orderCustomer="orderCustomer"  :salesAmount="salesAmount" :salesDataBar="salesDataBar" ></v-center>
      </div>
      <div class="right">
           <div class="item">
          <v-orderProductRanking  :commodityRanking="commodityRanking" v-if="show"></v-orderProductRanking>
        </div>
           <div class="item">
          <v-table  v-if="show" :salesDataRealTime="salesDataRealTime" ></v-table>
        </div>
      </div>
    </div>
       <!-- <div class="swiper-button-prev"  @click="prev"></div>
      <div class="swiper-button-next" @click="next"></div> -->
  </div>
</template>

<script>
import header from 'components/common/header'
import salesData from './components/salesData'
import table from './components/table'
import harvestingPlan from './components/harvestingPlan'
import orderProductRanking from './components/orderProductRanking'
import generatingData from './components/generatingData'
import center from './components/center'

export default {
  data() {
    return {
      name: '销售数据中心',
      show: false,
      commodityRanking: [],
      orderCustomer: "",
      regionalRanking: [],
      salesAmount: "",
      salesData: [],
      salesDataBar: [],
      salesDataRealTime: [],
      salesOrderAnalysis: [],
      salesDataCentertimer: null
    }
  },
  async  mounted() {
    let { err, res } = await this.$model('dataManagement').commonfn2(this.$apiUrl.DATAANALYSIS.salesDataCenter);
    if (res.state === 200) {
      let resultData = JSON.parse(res.results)
      this.commodityRanking = resultData.commodityRanking
      this.orderCustomer = resultData.orderCustomer
      this.regionalRanking = resultData.regionalRanking
      this.salesAmount = resultData.salesAmount
      this.salesData = resultData.salesData
      this.salesDataBar = resultData.salesDataBar
      this.salesDataRealTime = resultData.salesDataRealTime
      this.salesOrderAnalysis = resultData.salesOrderAnalysis
      this.show = true
    } else {
      this.$message.showError(err);
    }
    // this.salesDataCentertimer = setTimeout(() => {
    //   console.log("salesDataCentertimer")
    //   this.next()
    // }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.salesDataCentertimer);
    this.salesDataCentertimer = null;
  },
  methods: {
    next() {
      this.$router.push('/rundahelper');
    },
    prev() {
      this.$router.push('/rundatrace');
    }
  },
  components: {
    'v-header': header,
    'v-salesData': salesData,
    'v-table': table,
    'v-harvestingPlan': harvestingPlan,
    'v-generatingData': generatingData,
    'v-center': center,
    'v-orderProductRanking': orderProductRanking
  }
}

</script>

<style lang="less" scoped>
html,
body {
  width: 100%;
  height: 100%;
  background-color: #060606;
}

.item {
  margin-bottom: 15px;
}

.item2 {
  height: 300px;
}

.dashboard {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-size: 100% 100%;
}

.container {
  display: flex;
  width: 95%;
  height: 100%;
  margin: 0 auto;
  // border: 1px solid red;

  .center {
    width: 666 / 19.2vw;
    height: 80vh;
    margin: 0 auto;
    // border: 1px solid red;
  }

  .left,
  .right {
    width: 570 / 19.2vw;
    height: 80vh;
    // border: 1px solid red;
    .item {
      height: 39vh;
      margin-bottom: 2vh;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?8ac7aa82